import script from "./PubFreeDramasDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./PubFreeDramasDrawer.vue?vue&type=script&setup=true&lang=js"

import "./PubFreeDramasDrawer.vue?vue&type=style&index=0&id=75275051&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75275051"]])

export default __exports__